<template>
  <svg
    width="20"
    height="21"
    viewBox="0 0 20 21"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M10.8514 10.4026C13.3345 10.4026 15.3475 8.47353 15.3475 6.09389C15.3475 3.71424 13.3345 1.78516 10.8514 1.78516C8.3683 1.78516 6.35535 3.71424 6.35535 6.09389C6.35535 8.47353 8.3683 10.4026 10.8514 10.4026Z"
      fill="var(--primary-blue)"
    />
    <path
      d="M5.72461 17.9576L10.869 18.25C12.0435 18.3215 13.2018 17.9537 14.101 17.2258L18.6174 13.567C19.1179 13.1198 19.1287 12.3634 18.6418 11.902C18.2716 11.5523 17.7087 11.4704 17.2462 11.6979L12.8817 13.8516"
      stroke="var(--primary-blue)"
      stroke-width="1.5"
      stroke-linejoin="round"
    />
    <path
      d="M3.61963 13.9559L7.15138 12.517C7.67897 12.3026 8.26082 12.2363 8.82639 12.326L11.9458 12.8238C12.5358 12.9174 12.94 13.4451 12.8586 14.0118C12.7813 14.5538 12.2849 14.9489 11.7153 14.9242L8.64193 14.7916"
      stroke="var(--primary-blue)"
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M3.40638 12.5631L2.05205 12.8695C1.47102 13.0009 1.11117 13.5588 1.24831 14.1156L2.46149 19.0416C2.59862 19.5984 3.18081 19.9433 3.76184 19.8118L5.11617 19.5055C5.6972 19.3741 6.05705 18.8162 5.91992 18.2593L4.70674 13.3334C4.5696 12.7766 3.98741 12.4317 3.40638 12.5631Z"
      fill="var(--primary-blue)"
    />
    <path
      d="M10.8514 4.21289V7.97442"
      stroke="white"
      stroke-width="1.5"
      stroke-miterlimit="10"
      stroke-linecap="round"
    />
    <path
      d="M8.88879 6.09375H12.8139"
      stroke="white"
      stroke-width="1.5"
      stroke-miterlimit="10"
      stroke-linecap="round"
    />
  </svg>
</template>

<script setup></script>

<style scoped>
  /* Add custom styles if needed */
</style>
